import { Card, CardContent, Grid, Skeleton, Stack } from '@all-manager/design-system-v2';

const COLUMNS = [0, 1, 2];

/** Mirrors the comparison (one card per quote) while it loads. */
export default function QuoteComparisonSkeleton() {
  return (
    <Grid container spacing={2} aria-busy="true" aria-label="Chargement des devis">
      {COLUMNS.map((column) => (
        <Grid key={column} size={{ xs: 12, sm: 6, md: 4 }}>
          <Card>
            <CardContent>
              <Stack spacing={1}>
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
                <Skeleton variant="rounded" height={120} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
